import { render } from "./sectionReadConfig.vue?vue&type=template&id=c43bac58&scoped=true&ts=true"
import script from "./sectionReadConfig.vue?vue&type=script&lang=ts"
export * from "./sectionReadConfig.vue?vue&type=script&lang=ts"

import "./sectionReadConfig.vue?vue&type=style&index=0&id=c43bac58&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c43bac58"]])

export default __exports__